import './App.css';
import React, { useState, useEffect } from 'react';
import Calendar from './Calendar';
import Todo from './Todo';
import Studyroom from './Studyroom';
import Scheduler from './Scheduler';
import axios from 'axios';
import Cookies from 'js-cookie';


function App() {
  const [activeDay, setActiveDay] = useState(new Date().getDate());
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://capstone-31lo.onrender.com";

  // defining state variable "tasks" and using lazy initalization
  const [tasks, setTasks] = useState(() => {
    const savedTasks = JSON.parse(localStorage.getItem("tasks"));
    return savedTasks || [];  
  });

  // defining state variable "eventsArr" and using lazy initalization
  const [eventsArr, setEventsArr] = useState(() => {
    const savedEvents = JSON.parse(localStorage.getItem("events"));
    return savedEvents || [];
  });

  // use to update header with room code
  const [roomCode, setRoomCode] = useState("");
  const [roomURL, setRoomURL] = useState("");
  const [roomID, setRoomID] = useState(null);
  //const [loggedin, setloggedin] = useState(false);

  const [findCode, setFindCode] = useState('');
  const [showFindInput, setShowFindInput] = useState(false);

  const [showBanner, setShowBanner] = useState(false);

  // saving task strings to local storage, updating when "tasks" changes
  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  // saving event objects to local storage, updating when "eventsArr" changes
  useEffect(() => {
    localStorage.setItem("events", JSON.stringify(eventsArr));
  }, [eventsArr]);

  // 4/22 - - TEST    
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userIDFromUrl = params.get('roomCode');
    if (userIDFromUrl) {
      setRoomCode(userIDFromUrl); 
    }
  }, []);

  useEffect(() => {
      // Check  if the banner was already shown
      const bannerSeen = localStorage.getItem("bannerSeen");

      if (!bannerSeen) {
        setShowBanner(true);
        localStorage.setItem("bannerSeen", "true");
      }
    }, []);
  
  // Once roomCode is set, fetch events
  useEffect(() => {
    if (roomCode) {
      fetchEventsForUser(roomCode);
    }
  }, [roomCode]);
  
    // Fetch events from backend based on userID
    const fetchEventsForUser = async (roomCode) => {
      try {
        // Get room object using roomCode
        
        // Query to get RoomID from the "room" table using RoomCode
        const roomDetails = await axios.get(`${BACKEND_URL}/api/rooms/${roomCode}/`);
        const fetchedRoomID = roomDetails.data.RoomID;
        setRoomID(fetchedRoomID);
      
        // Now fetch events for that roomID
        const eventResponse = await axios.get(`${BACKEND_URL}/api/fetch_events/${roomCode}`);
        const userEvents = eventResponse.data;
        setEventsArr(userEvents);
        localStorage.setItem("events", JSON.stringify(userEvents));
        console.log("Fetched Events:", userEvents);

        // Plus fetch tasks 
        const taskResponse = await axios.get(`${BACKEND_URL}/api/fetch_tasks/${roomCode}`);
        const userTasks = taskResponse.data;
        setTasks(userTasks);
        localStorage.setItem("tasks", JSON.stringify(userTasks));
        console.log("Fetched Tasks:", userTasks);


      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    // 4/22 - - END TEST

  const addTask = (task) => {
    const updatedTasks = [...tasks, task];
    setTasks(updatedTasks);
    localStorage.setItem("tasks", JSON.stringify(updatedTasks));
  };

  const addEvent = async (event) => {
    const updatedEvents = [...eventsArr, event];
    setEventsArr(updatedEvents);
    localStorage.setItem("events", JSON.stringify(updatedEvents));
    // addTask(event.event_id);
    //addTask(event.EventName);
    // addTask(event.events[0].title);
    addTask({
      text: event.EventName,
      x: 50,
      y: 50
    });
    await fetchEventsForUser(roomCode);
  };

  // Deletes an event from the backend
  const deleteEventfromBackend = async (eventID) => {
    console.log("Calling backend delete for eventId:", eventID);
    try {
      const response = await fetch(`${BACKEND_URL}/api/delete_event/${eventID}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('event_id not found');
      }
  
      const data = await response.json();
      console.log(data.message);
      return data;

    }catch (error) {
      console.error("Delete error:", error);
      throw error;
    }
  };

  const deleteTask = async (taskID) => {
    console.log("Calling backend to delete task for ID:", taskID);
    try {
      const response = await fetch(`${BACKEND_URL}/api/delete_task/${taskID}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setTasks((tasks) =>
        tasks.filter((task) => task.task_id !== taskID)
    );
      if (!response.ok) {
        throw new Error('task_id not found');
      }

      const data = await response.json();
      console.log(data.message);
      return data;
    } catch (error) {
      console.error("Delete error:", error);
      throw error;
    }
  };

  const deleteEventAndTask = async (eventToDelete, taskToDelete) => {
    console.log("eventToDelete:", eventToDelete);
    console.log("event_id:", eventToDelete?.event_id);
    console.log("taskToDelete:", taskToDelete);
    console.log("task_id:", taskToDelete?.task_id);
  
    // Determine if we have an id
    const eventId = eventToDelete?.event_id;
    const taskId = taskToDelete;
  
    // Delete from backend & local if event_id is available
    if (eventId) {
      // delete from backend
      await deleteEventfromBackend(eventToDelete.event_id);
    
      // Remove event from state
      setEventsArr((prevEvents) =>
        prevEvents.filter((event) => event.event_id !== eventToDelete.event_id)
      );
    }
    // if no event_id is available (a task)
    else {
      console.log("no event found to delete");
      } 
    // Delete from backend & local if task_id is available
    if (taskId) {
      // delete task from backend
      await deleteTask(taskToDelete.task_id);
      // remove task from local 
      setTasks((tasks) =>
        tasks.filter((task) => task.task_id !== taskToDelete.task_id)
    );
    }  
  };
  
  // NEW - -
  const addRoom = (newRoom) => {
    setRoomCode(newRoom.RoomCode);
    setRoomURL(newRoom.RoomURL);
    window.location.replace(newRoom.RoomURL);
  };

  const generateRoomCode = () => {
		const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let code = "";
		for (let i = 0; i < 6; i++) {
			code += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return code;
	};
  
  const createRoom = async () => {
	  const code = generateRoomCode();
	  /* const url = `http://localhost:3000/?roomCode=${code}`; */
    const url = `https://groupwork.live/?roomCode=${code}`; 
	  
	  const newRoom = {
	    RoomCode: code,
	    RoomURL: url,
	  }

	  /* const csrfToken = Cookies.get('csrftoken'); */
	  
	  axios.post(`${BACKEND_URL}/api/add_room/`, newRoom, {
		headers: {
		"X-CSRFToken": Cookies.get("csrftoken"), 
		"Content-Type": "application/json",
		},
		
		withCredentials: true, 
	  })
      .then(response => {
        console.log("Room added: ", response.data);
        addRoom(newRoom);
      })
      .catch(error => {
        console.error("Error adding a room: ", error);
        alert("Error adding room.");
      });
    /*const updatedEvents = [...eventsArr, newEvent];
    setEventsArr(updatedEvents);
    localStorage.setItem("events", JSON.stringify(updatedEvents));*/
    
  };
 // NEW - -
 const findRoom = async () => {
  if (!showFindInput) {
    setShowFindInput(true); // First click: show input field
    return;
  }
  // check following on second click
  const isValidCode = /^[a-zA-Z0-9]{6}$/.test(findCode);
  if (!isValidCode) {
    alert("Room code must be exactly 6 characters")
  }
  try {
    const roomDetails = await axios.get(`${BACKEND_URL}/api/rooms/${findCode}/`);
    const fetchedRoomID = roomDetails.data.RoomID;
    setRoomID(fetchedRoomID);
    setRoomCode(findCode);
    setRoomURL(`https://groupwork.live/?roomCode=${findCode}`);
    window.location.replace(`https://groupwork.live/?roomCode=${findCode}`);
  }catch(error) {
    alert("Must be valid room code");
  }
 };

/*  const logout = () => {
   window.location.replace("${BACKEND_URL}/logout");
 }; */


  return (
    <div className="App">
      <div className="popup" style={ {display: showBanner ? 'block' : 'none'}}>
        <span>Welcome! This site is on a spindown server to conserve resources. Please allow up to a minute for your inital load.</span>
        <button className="popup-close" onClick={() => setShowBanner(false)}>
          ✕
        </button>
      </div>
      <header className="App-header">
        <h1>Welcome to your live group!</h1>
          {roomCode && (
          <div>
          <p><strong>Room Code:</strong> {roomCode}</p>
          <p><a href={roomURL} target="_blank" rel="noopener noreferrer">{roomURL}</a></p>
          </div>
          )}
        <div className="button-group">
          <button className="create-room" onClick={createRoom}>Create Room</button>
          <button className="find-room" onClick={findRoom}>Find Room</button>
          {/* <button className="log-out" disabled>Sign Out</button> */}
      </div>

      {showFindInput && (
        <input
          type="text"
          value={findCode}
          onChange={(e) => setFindCode(e.target.value)}
          placeholder="Enter 6 character room code"
          className="find-input"
        />
      )}
	  </header>
{/* */}
	  <main style={{ display: roomCode ? 'block' : 'none'}}>
		<Calendar
      eventsArr={eventsArr.filter(event => Number(event?.RoomID) === Number(roomID))}
      addEvent={addEvent}
      deleteEventAndTask={deleteEventAndTask}
    />
		<Todo tasks={tasks.filter(task => Number(task?.RoomID) === Number(roomID))} 
    addTask={addTask} 
    deleteTask={deleteTask}/>
    <Scheduler />
	  </main>	
    </div>
  );
  
}

export default App;
